import { Component, Input, OnInit } from "@angular/core";
import { AnexoTO } from "src/app/data/schema/Courses/AnexoTO";

@Component({
    selector: "app-attachment-image",
    templateUrl: "./attachment-image.component.html",
    styleUrls: ["./attachment-image.component.scss"]
})
export class AttachmentImageComponent implements OnInit {
    @Input("attachment")
    public attachment!: AnexoTO;

    constructor() {}

    ngOnInit() {}
}
